import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from 'src/helpers/TokenHelper';

const AuthRoute = (children) => {
  if (!getToken()) {
    return <Navigate to={`/login`} />;
  }

  return children.children;
};

export default AuthRoute;
